import React, { useMemo } from "react";
import {
  Image,
  Pressable,
  StyleProp,
  StyleSheet,
  Text,
  View,
  ViewStyle,
} from "react-native";
import LinearGradient from "react-native-linear-gradient";
import { useNavigation, useRoute } from "@react-navigation/native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import { useAuth } from "../../../context/AuthContext";

type Props = {
  title?: string;
  showBack?: boolean;
  showProfile?: boolean;
  showHome?: boolean;
  showUserName?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
};

export function Header({
  title = "",
  showBack = false,
  showProfile = true,
  showHome = false,
  showUserName = false,
  containerStyle,
}: Props) {
  const navigation = useNavigation<any>();
  const insets = useSafeAreaInsets();
  const { user } = useAuth();
  const route = useRoute<any>();

  const isDashboard = route?.name === "Dashboard";

  const userName = useMemo(
    () => (user?.name?.trim() ? user.name : "Devotee"),
    [user?.name]
  );

  return (
    <LinearGradient
      colors={["#F97316", "#F59E0B"]}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 0 }}
      style={[styles.bar, { paddingTop: insets.top }, containerStyle]}
    >
      <View style={styles.row}>
        <View style={styles.left}>
          {showBack ? (
            <Pressable
              onPress={() => navigation.goBack()}
              style={styles.backBtn}
            >
              <MaterialCommunityIcons
                name="arrow-left"
                size={22}
                color="#fff"
              />
            </Pressable>
          ) : null}

          {isDashboard ? (
            <View style={styles.dashboardBrand}>
              <View style={styles.logoWrap}>
                <Image
                  source={require("../../../assets/isckon.jpeg")}
                  style={styles.logo}
                  resizeMode="cover"
                />
              </View>
              <Text style={styles.dashboardTitle}>GAUR PREM AASHRAY</Text>
            </View>
          ) : (
            <View>
              <Text style={styles.title}>{title ?? ""}</Text>
              {showUserName ? (
                <Text style={styles.subTitle}>{userName}</Text>
              ) : null}
            </View>
          )}
        </View>

        <View style={styles.rightActions}>
          {showHome ? (
            <Pressable
              onPress={() => navigation.navigate("Dashboard")}
              style={styles.iconBtn}
            >
              <MaterialCommunityIcons
                name="home-outline"
                size={20}
                color="#fff"
              />
            </Pressable>
          ) : null}

          {showProfile ? (
            <Pressable
              onPress={() => navigation.navigate("EditProfile")}
              style={styles.profileBtn}
            >
              <MaterialCommunityIcons
                name="account-outline"
                size={20}
                color="#fff"
              />
            </Pressable>
          ) : !showHome ? (
            <View style={{ width: 44 }} />
          ) : null}
        </View>
      </View>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  bar: {
    width: "100%",
    shadowColor: "#000",
    shadowOpacity: 0.15,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 4 },
    elevation: 5,
  },

  row: {
    height: 60,
    paddingHorizontal: 14,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  left: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },

  rightActions: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },

  dashboardBrand: {
    flexDirection: "row",
    alignItems: "center",
    gap: 7,
  },

  logoWrap: {
    width: 42,
    height: 42,
    borderRadius: 14,
    backgroundColor: "rgba(255,255,255,0.20)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.35)",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },

  logo: {
    width: 36,
    height: 36,
    borderRadius: 12,
  },

  dashboardTitle: {
    color: "#FFF8E7",
    fontSize: 14,
    fontWeight: "900",
    letterSpacing: 0.6,
    textShadowColor: "rgba(124,45,18,0.35)",
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 2,
  },

  title: {
    color: "#FFFFFF",
    fontSize: 16,
    fontWeight: "900",
  },

  subTitle: {
    color: "rgba(255,255,255,0.92)",
    fontSize: 12,
    fontWeight: "800",
    marginTop: 2,
  },

  backBtn: {
    width: 40,
    height: 40,
    borderRadius: 14,
    backgroundColor: "rgba(255,255,255,0.18)",
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.35)",
  },

  iconBtn: {
    width: 42,
    height: 42,
    borderRadius: 14,
    backgroundColor: "rgba(255,255,255,0.18)",
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.35)",
  },

  profileBtn: {
    width: 42,
    height: 42,
    borderRadius: 14,
    backgroundColor: "rgba(255,255,255,0.18)",
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.35)",
  },
});
